<template>
    <v-row justify="center">
        <v-dialog v-model="dialogDetails" persistent transition="dialog-bottom-transition">
            <v-card class="elevation-4">

                <!-- Title -->
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click.native="handleModalDetails">
                        <v-icon>fas fa-times-circle</v-icon>
                    </v-btn>

                    <v-toolbar-title>
                        <div class="text-h6 font-weight-bold white--text">
                            Detalles de abonos del concepto: {{ deduccionSelected.concepto }}
                        </div>
                    </v-toolbar-title>
                </v-toolbar>

                <v-card-title>
                    <v-btn small dark color="cyan darken-4" @click="dialogAbono = true" v-if="deduccionSelected.saldoValor > 0">
                        <v-icon left>fas fa-plus-square</v-icon>Nuevo abono directo
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-title>

                <!-- Table -->
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="detailsList" sort-by="idAbonoDeduccion" class="elevation-1"
                    :server-items-length="totalElements" :items-per-page="itemsPerPage"
                    :page.sync="page" @page-count="totalPages = $event"
                    hide-default-footer>

                        <template v-slot:[`item.actions`]="{ item }">
                            <v-menu bottom offset-x rounded="lg" transition="slide-y-transition" color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" color="teal darken-1" class="white--text" small>
                                        <v-icon>fas fa-ellipsis-v</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item @click.prevent="showDetalleAbono(item)">
                                        <v-list-item-title>
                                            <v-icon small class="mr-2">fas fa-eye</v-icon> Ver detalle
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click.prevent="showCancelarAbono(item)" v-if="isAdmin && !item.eliminado">
                                        <v-list-item-title class="red--text">
                                            <v-icon small class="mr-2 red--text">fas fa-trash-alt</v-icon> Cancelar abono
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>

                        <template v-slot:[`item.monto`]="{ item }">
                            <span>{{ formatNumbertToMoney(item.monto) }}</span>
                        </template>

                        <template v-slot:[`item.rayaDetalle.raya.fechaInicio`]="{ item }">
                            <span v-if="item.rayaDetalle">{{ formatDatesToPeriod(item.rayaDetalle.raya.fechaInicio, item.rayaDetalle.raya.fechaFin) }}</span>
                            <span v-else>Abono directo</span>
                        </template>

                        <template v-slot:[`item.cashRegisterFolio`]="{ item }">
                            <span>{{ item.cashRegisterFolio || '-' }}</span>
                        </template>

                        <template v-slot:[`item.eliminado`]="{ item }">
                            <v-chip :color="item.eliminado ? 'error' : 'success'" label x-small dark
                                v-text="item.eliminado ? 'Cancelado' : 'Activo'">
                            </v-chip>
                        </template>

                    </v-data-table>
                </v-card-text>

                <!-- Pagination -->
                <v-card-actions>
                    <PaginationNumber :itemsPerPage.sync="itemsPerPage" :pageCount.sync="totalPages"
                    :totalElements.sync="totalElements" :page.sync="page" :initialize.sync="initialize" />
                </v-card-actions>

            </v-card>
        </v-dialog>
        <NuevoAbonoDirecto :dialog.sync="dialogAbono" :initialize.sync="initialize" :handleModal="handleModalAbono"
        :deduccionSelected.sync="deduccionSelected" v-if="dialogAbono">
        </NuevoAbonoDirecto>
        <DetalleAbono :dialog.sync="dialogDetalleAbono" :handleModal="handleModalDetalleAbono"
        :abonoSelected.sync="abonoSelected" v-if="dialogDetalleAbono">
        </DetalleAbono>
        <CancelarAbono :dialog.sync="dialogCancelarAbono" :initialize.sync="initialize" :handleModal="handleModalCancelarAbono"
        :abonoSelected.sync="abonoSelected" v-if="dialogCancelarAbono">
        </CancelarAbono>
    </v-row>
</template>

<script>
    import { parseDateNatural } from '@/utils/DateUtil';
    import { getFormatCurrency } from '@/utils/CurrencyUtil';
    import { pagedTableMixin } from '@/mixins/serverTableMixin';
    import PaginationNumber from '@/components/shared/PaginationNumber.vue';
    import AbonoDeduccionDataService from '@/service/deduccion/AbonoDeduccionDataService';
    import UsuarioDataService from '@/service/usuario/UsuarioDataService';
    import NuevoAbonoDirecto from './NuevoAbonoDirecto.vue';
    import DetalleAbono from './DetalleAbono.vue';
    import CancelarAbono from './CancelarAbono.vue';
import { extractMessage } from '@/helpers/errorHelper';
import { can, CAP } from '@/service/permiso/capacidades';

    export default {
        name: "MostrarDetalles",
        props: {
            dialogDetails: { type: Boolean, default: false },
            handleModalDetails: { type: Function },
            deduccionSelected: { type: Object, default: {} },
        },
        mixins: [pagedTableMixin],
        components: { PaginationNumber, NuevoAbonoDirecto, DetalleAbono, CancelarAbono },
        created() {
            this.fetchTableData();
        },
        data() {
            return {
                headers: [
                    { text: "id", align: " d-none", sortable: false, value: "id", visible: false },
                    { text: "Acciones", value: "actions", sortable: false },
                    { text: "Monto", value: "monto", sortable: false },
                    { text: "Periodo de pago", value: "rayaDetalle.raya.fechaInicio", sortable: false },
                    { text: "Caja", value: "cashRegisterFolio", sortable: false },
                    { text: "Estatus", value: "eliminado", sortable: false },
                ],
                search: "",
                page: 1,
                totalPages: 0,
                itemsPerPage: 25,
                totalElements: 0,

                detailsList: [],
                dialogAbono: false,
                dialogDetalleAbono: false,
                dialogCancelarAbono: false,
                abonoSelected: {},
            }
        },
        methods: {
            handleModalAbono() { this.dialogAbono = !this.dialogAbono; },
            handleModalDetalleAbono() { this.dialogDetalleAbono = !this.dialogDetalleAbono; },
            handleModalCancelarAbono() { this.dialogCancelarAbono = !this.dialogCancelarAbono; },
            showDetalleAbono(item) {
                this.abonoSelected = item;
                this.dialogDetalleAbono = true;
            },
            showCancelarAbono(item) {
                this.abonoSelected = item;
                this.dialogCancelarAbono = true;
            },
            // Table Methods
            searchAbonoDeduccion() {
                this.doSearch();
            },
            fetchTable(params){
                return AbonoDeduccionDataService.tableByDeduccion(this.deduccionSelected.id, params );
            },
            applyRows({ rows, total, totalPages }){
                this.detailsList = rows;
                this.totalElements = total;
                this.totalPages = totalPages;
            },
            formatDatesToPeriod( startDate, endDate ) {
                const formattedStartDate = parseDateNatural(startDate);
                const formattedEndDate = parseDateNatural(endDate);

                return `del ${formattedStartDate} al ${formattedEndDate}`
            },
            formatNumbertToMoney( number ) {
                const formattedNumber = parseFloat(number);
                return getFormatCurrency(formattedNumber, "$");
            }
        },
        computed: {
            isAdmin(){ return can(CAP.ADMIN, UsuarioDataService.getUserRoles()); }
        }
    }
</script>
